import async from 'async';
import utils from '@/utils';

const search = (options, commit, callback) => {
  utils.send({
    path: '/users/search',
    options: {
      page: options.page,
      limit: options.limit,
      sortBy: options.sortBy,
      sortDesc: options.sortDesc,
      conditions: options.conditions,
    },
    callback(data) {
      commit('search', data);
      callback(null);
    },
  });
};

const find = (id, commit, callback) => {
  utils.send({
    path: '/users/find',
    params: [id],
    callback(data) {
      commit('loadForm', data.item);
      callback(null);
    },
  });
};

export default {
  searchList: ({ state, commit }, { page, limit, sortBy, sortDesc, conditions }) => {
    search({
      page: page,
      limit: limit,
      sortBy: sortBy,
      sortDesc: sortDesc,
      conditions: conditions,
    }, commit, (err) => {
      if (err) {
        utils.error('illegal');
      }
    });
  },

  addItem: ({ state, commit }, form) => {
    async.waterfall([
      (next) => {
        utils.send({
          path: '/users/add',
          options: {
            company: form.company,
            name: form.name,
            email: form.email,
            comment: form.comment,
          },
          callback(data) {
            utils.success('usersAdd');
            next(null, data.id);
          },
        });
      },
      (id, next) => { find(id, commit, next); },
    ], (err) => {
      if (err) {
        utils.error('illegal');
      }
    });
  },

  updateItem: ({ state, commit }, form) => {
    async.waterfall([
      (next) => {
        utils.send({
          path: '/users/update',
          params: [form.id],
          options: {
            company: form.company,
            name: form.name,
            email: form.email,
            comment: form.comment,
          },
          callback(data) {
            utils.success('usersUpdate');
            next(null);
          },
        });
      },
      (next) => { find(form.id, commit, next); },
    ], (err) => {
      if (err) {
        utils.error('illegal');
      }
    });
  },

  deleteItem: ({ state, commit }, id) => {
    async.waterfall([
      (next) => {
        utils.send({
          path: '/users/delete',
          params: [id],
          callback(data) {
            utils.success('usersDelete');
            next(null);
          },
        });
      },
      (next) => { search(state, commit, next) },
    ], (err) => {
      if (err) {
        utils.error('illegal');
      }
    });
  },

  loadForm: ({ state, commit }, id) => {
    find(id, commit, (err) => {
      if (err) {
        utils.error('illegal');
      }
    });
  },

  clearForm: ({ state, commit }) => {
    commit('clearForm');
  },

  code: ({ state, commit }, id) => {
    utils.send({
      path: '/users/code',
      params: [id],
      callback(data) {
        utils.success('usersCode');
      },
    });
  },
};
